// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0e45e25a] .ant-form-item {\n  display: flex;\n  align-items: center;\n}\n[data-v-0e45e25a] .ant-form-item .ant-form-item-control-wrapper,[data-v-0e45e25a] .ant-form-item .ant-calendar-picker,[data-v-0e45e25a] .ant-form-item .ant-select {\n  flex: 1;\n  overflow: hidden;\n}\n[data-v-0e45e25a] .ant-form-item .ant-form-item-children {\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
